import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'printers',
    pluginName: 'SETTINGS',
    entityName: 'PRINTER',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch printer action creators
export const fetchPrinterInit = () => {
    return crudActions.fetchInit();
};
export const fetchPrinterStart = () => {
    return crudActions.fetchStart();
};
export const fetchPrinterSuccess = (fetchPrinterCount, listPrinterCount) => {
    return crudActions.fetchSuccess(fetchPrinterCount, listPrinterCount);
};
export const fetchPrinterFail = () => {
    return crudActions.fetchFail();
};
export const fetchPrinterCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchPrinterStart());
        try {
            let countRes = await rest.post("printers/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchPrinterSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchPrinterFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch printers."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchPrinterFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch printers."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchPrinter = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchPrinterStart());
        try {
            let listRes = await rest.post("printers/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchPrinterSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchPrinterFail());
            return []

        } catch (error) {
            dispatch(fetchPrinterFail());
            return []
        }
    }
}

// Load printer action creators
export const loadPrinterInit = () => {
    return crudActions.loadInit();
};
export const loadPrinterStart = () => {
    return crudActions.loadStart();
};
export const loadPrinterSuccess = loadedPrinter => {
    return crudActions.loadSuccess(loadedPrinter);
};
export const loadPrinterFail = error => {
    return crudActions.loadFail(error);
};
export const loadPrinter = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create printer  action creators
export const createPrinterInit = () => {
    return crudActions.createInit();
};
export const createPrinterStart = () => {
    return crudActions.createStart();
};
export const createPrinterSuccess = createdPrinter => {
    return crudActions.createSuccess(createdPrinter);
};
export const createPrinterFail = error => {
    return crudActions.createFail(error);
};

export const createPrinter = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createPrinterStart());
        try {
            let res = await rest.post('/printers/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createPrinterSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created printer.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createPrinterFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create printer."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create printer."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createPrinterFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit printer  action creators
export const editPrinterInit = () => {
    return crudActions.editInit();
};
export const editPrinterStart = () => {
    return crudActions.editStart();
};
export const editPrinterSuccess = editedPrinter => {
    return crudActions.editSuccess(editedPrinter);
};
export const editPrinterFail = error => {
    return crudActions.editFail(error);
};
export const editPrinter = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editPrinterStart());
        try {
            let res = await rest.post('/printers/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editPrinterSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated printer.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editPrinterFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit printer."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit printer."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editPrinterFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete printer action creators
export const bulkDeletePrintersInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeletePrintersStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeletePrintersSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeletePrintersFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeletePrinters = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeletePrintersStart());
        try {
            let res = await rest.post('/printers/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeletePrintersSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted printers.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeletePrintersFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete printers."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete printers."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeletePrintersFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

